import { render, staticRenderFns } from "./AddBuildingButton.vue?vue&type=template&id=2afb56eb&scoped=true"
import script from "./AddBuildingButton.vue?vue&type=script&lang=js"
export * from "./AddBuildingButton.vue?vue&type=script&lang=js"
import style0 from "./AddBuildingButton.vue?vue&type=style&index=0&id=2afb56eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb56eb",
  null
  
)

export default component.exports